import { render, staticRenderFns } from "./page10.vue?vue&type=template&id=25a9556c&scoped=true&"
import script from "./page10.vue?vue&type=script&lang=js&"
export * from "./page10.vue?vue&type=script&lang=js&"
import style0 from "./page10.vue?vue&type=style&index=0&id=25a9556c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a9556c",
  null
  
)

export default component.exports